import React from "react";
import { Box, Button, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography, } from "@material-ui/core";
import { Delete, GetApp } from "@material-ui/icons";
import { useClientActivityLogFileInfo, useClientActivityLogs, } from "frontend/src/domain/client";
import { useDeleteClientActivityLogFile } from "frontend/src/domain/client/actions";
import { apiURL } from "frontend/src/api/client";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { ButtonLoader } from "frontend/src/ui/button-loader";
var getUserTitle = function (user) {
    if (!user) {
        return "-";
    }
    return user.name || user.email || "-";
};
var formatBytes = function (value) {
    if (value === undefined) {
        return "-";
    }
    if (value < 1024) {
        return value + " \u0411";
    }
    if (value < 1024 * 1024) {
        return (value / 1024).toFixed(1) + " \u041A\u0411";
    }
    return (value / 1024 / 1024).toFixed(1) + " \u041C\u0411";
};
var getDescription = function (type, log) {
    var _a, _b, _c, _d;
    if (type !== "track") {
        return log.description || log.path || "-";
    }
    var title = ((_a = log.context) === null || _a === void 0 ? void 0 : _a.trackTitle) || log.description || "-";
    var artist = (_b = log.context) === null || _b === void 0 ? void 0 : _b.artist;
    var duration = ((_c = log.context) === null || _c === void 0 ? void 0 : _c.playDuration)
        ? ", " + log.context.playDuration + " \u0441\u0435\u043A."
        : "";
    var device = ((_d = log.context) === null || _d === void 0 ? void 0 : _d.deviceId) ? ", \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E #" + log.context.deviceId : "";
    return "" + (artist ? artist + " - " : "") + title + duration + device;
};
var ActivityTable = function (_a) {
    var _b, _c;
    var clientId = _a.clientId, type = _a.type;
    var logs = useClientActivityLogs(clientId, { type: type, take: 100 });
    return (React.createElement(TableContainer, null,
        React.createElement(Table, { size: "small" },
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, null, "\u0414\u0430\u0442\u0430"),
                    React.createElement(TableCell, null, "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C"),
                    React.createElement(TableCell, null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435"),
                    React.createElement(TableCell, null, "\u0421\u0442\u0430\u0442\u0443\u0441"),
                    React.createElement(TableCell, null, "IP"))),
            React.createElement(TableBody, null,
                !logs.data && React.createElement(TableRowsSkeleton, { rows: 5, columns: 5 }),
                ((_b = logs.data) === null || _b === void 0 ? void 0 : _b.length) === 0 && (React.createElement(TableRow, null,
                    React.createElement(TableCell, { colSpan: 5 },
                        React.createElement(Typography, { variant: "body2" }, "\u0417\u0430\u043F\u0438\u0441\u0435\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442.")))), (_c = logs.data) === null || _c === void 0 ? void 0 :
                _c.map(function (log) { return (React.createElement(TableRow, { key: log.id },
                    React.createElement(TableCell, null, log.createdAt),
                    React.createElement(TableCell, null, getUserTitle(log.user)),
                    React.createElement(TableCell, null, getDescription(type, log)),
                    React.createElement(TableCell, null, log.statusCode || "-"),
                    React.createElement(TableCell, null, log.ip || "-"))); })))));
};
export var ClientActivityLogs = function (_a) {
    var _b;
    var clientId = _a.clientId;
    var _c = React.useState("login"), type = _c[0], setType = _c[1];
    var fileInfo = useClientActivityLogFileInfo();
    var deleteFile = useDeleteClientActivityLogFile();
    var changeType = function (_, value) {
        return setType(value);
    };
    var removeLogFile = function () {
        if (window.confirm("Перед удалением лог будет отправлен на почту текущего администратора. Удалить лог?")) {
            deleteFile.mutate();
        }
    };
    return (React.createElement(Paper, null,
        React.createElement(Box, { px: 2, pt: 2, display: "flex", alignItems: "center", justifyContent: "space-between" },
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "h6" }, "\u0410\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u043A\u043B\u0438\u0435\u043D\u0442\u0430"),
                React.createElement(Typography, { variant: "body2", color: "textSecondary" },
                    "\u0424\u0430\u0439\u043B \u043B\u043E\u0433\u0430: ",
                    formatBytes((_b = fileInfo.data) === null || _b === void 0 ? void 0 : _b.size))),
            React.createElement(Box, { display: "flex", gridGap: 8 },
                React.createElement(Button, { component: "a", href: apiURL + "/admin/client-activity-log-file/download", color: "primary", variant: "outlined", startIcon: React.createElement(GetApp, { fontSize: "small" }) }, "\u0421\u043A\u0430\u0447\u0430\u0442\u044C"),
                React.createElement(ButtonLoader, { color: "secondary", variant: "outlined", startIcon: React.createElement(Delete, { fontSize: "small" }), isLoading: deleteFile.isLoading, onClick: removeLogFile }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"))),
        React.createElement(Tabs, { value: type, onChange: changeType, indicatorColor: "primary", textColor: "primary" },
            React.createElement(Tab, { value: "login", label: "Входы" }),
            React.createElement(Tab, { value: "action", label: "Действия" }),
            React.createElement(Tab, { value: "track", label: "Треки" })),
        React.createElement(ActivityTable, { clientId: clientId, type: type })));
};
